module.exports = __webpack_public_path__ + "assets/img/advantage-item1.d4d6815a.png";